import React, { useState } from 'react';
import { FormControl, FormLabel } from '@stockx/ui';
import { SearchBoxSite } from '@app/catalog';

interface ProductSearchProps {
  label?: string;
  onSelect: Function;
}

const ProductSearch: React.FC<ProductSearchProps> = ({
  label = 'Which product would you like to sell?',
  onSelect,
}) => {
  const [searchValue, setSearchValue] = useState('');

  return (
    <FormControl p={8} pt={6}>
      <FormLabel htmlFor="site-search" fontWeight="bold">
        {label}
      </FormLabel>
      <SearchBoxSite
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'Function' is not assignable to type '(select... Remove this comment to see the full error message
        selectCallback={onSelect}
        source="action-form"
        resultsInline
        value={searchValue}
        setSearchValue={(value) => setSearchValue(value)}
      />
    </FormControl>
  );
};

export default ProductSearch;
